import React, { useEffect } from "react";
import CompaniesParametros from "../components/Parametros/CompaniesParametros";
import i18n from "../i18n/config";

const EmpresasParametrosPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("pageTitle", { ns: "empresaParametros" })}`;
  }, []);

  return <CompaniesParametros />;
};

export default EmpresasParametrosPage;
